module.exports = __webpack_public_path__ + "mastercard.png?acf1c8eef9006ad66f3878a26e20c7aa";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paymentIcons/mastercard.png
// module id = 368
// module chunks = 0